<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { real_id } from '../../../helpers/interface_helpers';
	import { getErrorOrInfoMessageForMinAndMax } from '../../../helpers/utilities';
	import { onSettingsResponse } from '../../../helpers/device_settings_helpers';
	import {
		buildTemperatureSetConfigParams,
		usesVentoraMergedSensorSetConfig,
	} from '../../../helpers/sensor_config_helpers';
	//Services
	import { gen2Request } from '../../../services/gen_2_http_reqs';
	//Stores
	import { getDeviceStatus, getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Button, Input, Text } from '@Shelly/shelly-design-system';
	//Types
	import type { Device } from '../../../types/Device';

	export let device: Device;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	$: settings = $settingsStore;
	const localUnit = settings?.ht_ui?.temperature_unit || 'C';

	let min = 0.5;
	let max = 5;
	let value = settings?.['temperature:0']?.report_thr_C;
	let waitForResponse = false;
	let unit = localUnit;

	const save = async () => {
		waitForResponse = true;

		const params = usesVentoraMergedSensorSetConfig(device)
			? buildTemperatureSetConfigParams(settings, device.channel, {
					report_thr_C: value,
				})
			: {
					id: device.channel,
					config: { report_thr_C: value },
				};

		const res = await gen2Request(device, 'Temperature.SetConfig', params);
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: inputData = getErrorOrInfoMessageForMinAndMax(value, min, max);

	const handleChange = (e) => {
		value = e.target.value;
	};
</script>

<!-- <Alert
	class="mb-s"
	heading={$format('alert_info_heading_temp_thres_trig_wake_up', {
		default: 'Threshold for triggering a device wake up'
	})}
	message={$format('alert_info_message_temp_thres_trig_sensor_data', {
		values: { unit },
		default: `Temperature change with more than the specified value in °${unit} triggers sensor data report.`
	})}
	isHeadingBold
/> -->

<Text styleType="body-small" class="mb-s"
	>{$format('alert_info_message_temp_thres_trig_sensor_data', {
		values: { unit },
		default: `Temperature change with more than the specified value in °{unit} triggers sensor data report.`,
	})}</Text
>

<Input
	size="m"
	class="mb-s"
	icon="fas fa-calculator"
	on:input={(e) => handleChange(e)}
	{value}
	info={inputData.info}
	error={inputData.error}
	type="number"
	step={0.5}
	id="input-7ys9fq0"
	aria-label={$format('sub_settings_title_temperature_threshold', {
		default: 'Temperature threshold',
	})}
/>

<Button size="m" width="full" loading={waitForResponse} disabled={inputData.error} on:click={save}>
	{$format('button_save', { default: 'Save' })}
</Button>
